import React, { memo, useRef, useState } from "react";

import AutoComplete from "../AutoComplete";
import styles from "../style.css";
import {useTranslation} from "react-i18next";
import {getSearchPlaceholder} from "src/utils";


const GoogleWsSearchBar = memo(props => {
  const {
    autoFocus,
    brand = "",
    searchBarPlaceholderText = "Search the web...",
    searchBarBtnColor = "#2593e6",
    searchLabel = "Search",
    autocomplete
  } = props;

  const form = useRef();
  const [value, setValue] = useState("");
  const {t: translator} = useTranslation();

  const submitValue = val => {
    setValue(val);
    setTimeout(() => form.current.submit(), 100);
  };

  const handleSubmit = e => value.trim() === "" && e.preventDefault();

  const searchPlaceholder = getSearchPlaceholder(searchBarPlaceholderText, translator);

  return (
    <div class={styles.googleWmSearchBar}>
      <form ref={form} id="cse-search-box" action="/search/gcse" onSubmit={handleSubmit}>
        <div class={styles.googleWmSearchBarInputs}>
          <input type="hidden" name="brand" value={brand} />
          <input type="hidden" name="ie" value="UTF-8" />
          <div class={styles.googleWmSearchBarSearchText}>
            <input
              type="text"
              placeholder={searchPlaceholder}
              autoComplete="off"
              autoFocus={autoFocus}
              value={value}
              onChange={e => setValue(e.target.value)}
            />
          </div>
          <div style={{ background: searchBarBtnColor }}>
            <button alt="Submit" class={styles.googleSearchBtn} name="sa" value={translator(`Search.${searchLabel}`)}>
              <img class={styles.searchBtnIcon} src={`${window.GLOBALS.ASSETS.GENERIC}/img/icon-search.png`} />
            </button>
          </div>
        </div>
      </form>
      {autocomplete ? <AutoComplete query={value} setQuery={submitValue} /> : null}
    </div>
  );
});

export default GoogleWsSearchBar;
